import styled from "styled-components";

const Container = styled.div`
max-width: 1360px;
width: 100%;
min-width: 340px;
padding: 15px;
margin: 0 auto;
height: 100%;

@media (max-width: 726px) {
    padding: 15px;
`

export default Container